
import Vue from "vue";
import anime from 'animejs';
import axios from "axios";
import { CustomReports, DashboardReports, MenuItem } from "types/Sapphire_dto";

export default Vue.extend({
    name: "report-control",
	components: {
	},
    props: {
		facID: String,
		usrID: String
	},
	data: function () {
		return {
			widthModifier: 'one-third',
			sectionTitle: 'Custom Reports',
			sectionTitleURL: 'CustomReportBrowser.aspx',
			leftListTitle: 'Reports',
			rightListTitle: 'Favorites',
			leftList: [],
			rightList: [],
			activeTab: '',
			loading: false,
			showRemove: false,
			errored: false,
			noReports: false,
			FavoriteReports: [] as MenuItem[],
			FavoriteCustomReports: [] as CustomReports[],
			isErrored: false,
			dashReports:new Object as DashboardReports,
		}
	},
	computed: {
		dashboardWidthModifier(): string {
		return 'dashboard-' + this.widthModifier + '-item-div';
		},
	},
	watch: {
		facID: function(newVal, oldVal) {
			if (newVal != oldVal) {
				this.loadData();
			}
		},
		FavoriteReports: function (val, oldVal) {
			if(val != oldVal) {
				this.rightList = val;
			}
		},
		FavoriteCustomReports: function (val) {
			this.rightList = val;
		},
		activeTab: function (val, oldVal) {
			if(val != oldVal) {
				this.displayActiveTab();
			}
		},
	},
	methods: {
		async loadData() {
			this.errored = false;
			this.loading = true;

			const response = await axios.post("../../Common/Services/EmarClientOperations.svc/GetDashboardReports_Vue",
				{   facilityID:  this.facID,
					userID: this.usrID },
			);

			this.dashReports = JSON.parse(response.data.d);

			if (this.dashReports == null || typeof this.dashReports == 'undefined') {
				this.sectionTitle = "Reports";
				this.sectionTitleURL = "Reports.aspx";
				this.errored = true;
				this.noReports = true;
				this.loading = false;
				return;
			}
			this.activeTab="Resources";
			this.FavoriteCustomReports = this.dashReports.FavoriteCustomReports;
			this.FavoriteReports = this.dashReports.FavoriteReports;
			this.loading = false;

		},/* .fail(function (jqXHR, statusText, errorThrown) {
			reportControlData.reporting.sectionTitle = "Reports";
			reportControlData.reporting.sectionTitleURL = "Reports.aspx";
			reportControlData.isErrored = true;
			reportControlData.isLoading = false;
			onMethodFailedCallBack(jqXHR, statusText, errorThrown);
		}) */

		//return reportControlData; */

	
		displayActiveTab: function () {

			var wrapper = document.getElementById('divReportWrapper');
			var transition = false;

			if (this.activeTab === "Custom" && this.sectionTitle != "Custom Reports") {
				this.sectionTitle = "Custom Reports";
				this.sectionTitleURL = "CustomReportBrowser.aspx";
				this.leftListTitle = "Reports"
				this.rightListTitle = "Favorites"
				this.leftList = this.dashReports.CustomReports;
				this.rightList = this.FavoriteCustomReports;
				this.showRemove = this.FavoriteCustomReports.length > 0 ? true : false;
				transition = true;
			}
			else if (this.activeTab === "Report" && this.sectionTitle != "Reports") {
				this.sectionTitle = "Reports";
				this.sectionTitleURL = "Reports.aspx";
				this.leftListTitle = "Reports"
				this.rightListTitle = "Favorites"
				this.leftList = this.dashReports.Reports;
				this.rightList = this.FavoriteReports;
				this.showRemove = this.FavoriteReports.length > 0 ? true : false;
				transition = true;
			}
			else if (this.activeTab === "Resources" && this.sectionTitle != "Resources") {

				var tmp = [];

				tmp.push({
					'URL': 'javascript:tb_show();sapphire.facilityDocumentsPopup.showPopup();',
					'Title': 'Facility Documents'
				});

				this.dashReports.Documents.forEach(function (i) { tmp.push(i); });

				this.sectionTitle = "Resources";
				this.leftListTitle = "Websites"
				this.rightListTitle = "Documents"
				this.leftList = this.dashReports.Websites;
				this.rightList = tmp;
				this.showRemove = false;
				transition = true;
			}

			if (transition) {

				if (wrapper) {
					wrapper.style.cssText = "opacity:0;transform:translateX(10%)";
				}

				anime({
					targets: wrapper,
					opacity: 1,
					translateX: 0,
					easing: 'easeOutQuad',
					duration: 400
				});

			}
		},
		changeReportType: function (buttonName: String) {

			switch (buttonName) {
				case "Custom Reports":
					this.activeTab = "Custom";
					break;
				case "Reports":
					this.activeTab = "Report";
					break;
				case "Resources":
					this.activeTab = "Resources";
					break;
			}

		},
		changeQuickLinksTab: function (event: { currentTarget: any; }) {
			var wrapper = document.getElementById('divReportWrapper');

			var button = event.currentTarget;
			var vm  = this;
			if (button.dataset.hint != this.sectionTitle) {

				anime({
					targets: wrapper,
					opacity: 0,
					translateX: '-10%',
					easing: 'easeInQuad',
					duration: 400,
					complete: function () {
						vm.changeReportType(button.dataset.hint);
					}
				});

			}
		},
		formatReportLink: function (link) {
			var currentLink = window.location.origin;
			if (link.indexOf("~/") !== -1) {
				return currentLink + link.substring(1);
			}
			else {
				return link;
			}
		},
		formatCustomLink: function (report: CustomReports) {
			var currentLink = window.location.origin;
			if (report.DownloadURL) {
				if (report.DownloadURL.indexOf("~/") !== -1) {
					return currentLink + report.DownloadURL.substring(1);
				}
				else {
					return report.DownloadURL;
				}
			}
			else {
				return currentLink + '/Main/Pages/CustomReportBrowser.aspx';
			}

		},
		getTarget: function (link: string | string[]){
			if (link.indexOf("http") == 0) {
				return "_blank";
			}
			else {
				return "";
			}
		},
		async removeFavoriteReport(report: MenuItem, event: MouseEvent) {
			event.preventDefault();

			const result = await this.$swal({
				title: 'Are you sure?',
				text: 'This will remove ' + (report.Title) + ' from the favorites list.',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Save',
				allowOutsideClick: false
			});

			if (result.isConfirmed) {
				const response = await axios.post("../../Common/Services/EmarClientOperations.svc/RemoveFavoriteReport_Vue",
				{
						favID: report.FavoriteID,
						facilityID: this.facID,
						userID: this.usrID
				})
			
				this.FavoriteReports = JSON.parse(response.data.d);
			}
		},
		async removeCustomFavorite(report: CustomReports, event: { preventDefault: () => void; }) {
			event.preventDefault();
			const result = await this.$swal({
				title: 'Are you sure?',
				text: 'This will remove ' + (report.Name) + ' from the favorites list.',
				icon: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Save',
				allowOutsideClick: false
			});

			if (result.isConfirmed) {
				const response = await axios.post("../../Common/Services/EmarClientOperations.svc/RemoveFavoriteCustomReport_Vue",
					{
						favID: report.FavoriteID,
						userID: this.usrID
					},
				)
				this.FavoriteCustomReports = JSON.parse(response.data.d);
			}
		}
	}
});
			
